import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/lucky-spin/pointer.png'
import _imports_1 from '@/assets/img/lucky-spin/center.png'


const _hoisted_1 = { class: "lucky-spin-popup" }
const _hoisted_2 = { class: "spin-wrap" }
const _hoisted_3 = { class: "lucky-spin-banner" }
const _hoisted_4 = { class: "banner-title" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "reward-amount" }
const _hoisted_7 = { class: "banner-subtitle" }
const _hoisted_8 = { class: "lucky-wheel-bg" }
const _hoisted_9 = {
  key: 0,
  class: "prize-amount"
}
const _hoisted_10 = { class: "spin-info-wrap common-box-wrap" }
const _hoisted_11 = { class: "spin-info-header common-box-wrap flex justify-center" }
const _hoisted_12 = { class: "box-title" }
const _hoisted_13 = { class: "box-title" }
const _hoisted_14 = { class: "spin-btn-wrap flex justify-around" }
const _hoisted_15 = { class: "spin-winner-wrap" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSettingsStore } from '@/store';
import { useAudio, useHelpTool } from "@/hooks";
import SpinLog from './SpinLog.vue';
import Reward from './Reward.vue';
import Record from './Record.vue';
import WinnerRecord from './WinnerRecord.vue';
import GameBetTask from '@/components/GameBetTask/index.vue';
import Rule from './Rule.vue';
import { queryLuckySpin, spinLuckySpin, spinTenTimes } from '@/api'

const CIRCLE_ANGLE = 360;
const BIGSIZE = 18;


export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { playAudio } = useAudio();

const settingsStore = useSettingsStore()
const { luckySpinRewards } = storeToRefs(settingsStore);

const prizeList = ref([])
const rollStyle = ref('');
const showReward = ref(false)
const spinReward = ref({});
const prizeIndex = ref(0);
const spinChance = ref(0);
const spinJackpot = ref(0);
const logList = ref([])
const showRecord = ref(false);
const showWinnerRecord = ref(false);
const showRule = ref(false);


let angleList = [];
let isRotating = false;
let rotateAngle = 0;

onMounted(() => {
  prizeList.value = formatPrizeList(luckySpinRewards.value || []);
  fetchLuckySpin(true);
})

const fetchLuckySpin = (needUpdatePrizeList) => {
  queryLuckySpin().then(res => {
    const { awardlist, chance, jackpot, loglist } = res.data || [];
    spinJackpot.value = jackpot;
    spinChance.value = chance;
    logList.value = loglist || [];

    settingsStore.set('luckySpinRewards', awardlist || []);

    // redDotStore.set('inviteFriendToEarnNum', inviteRecord.value.spins);

    if (needUpdatePrizeList || prizeList.value.length == 0) {
      prizeList.value = formatPrizeList(awardlist || []);
      rollStyle.value ='';
      rotateAngle = 0;

      // countdown.value = inviteRecord.value.countdown;
      // coldDown();
    }
  })
}

const formatPrizeList = (list) => {
  const l = list.length;
  // 计算单个奖项所占的角度
  const average = CIRCLE_ANGLE / l; //60
  const half = average / 2; //30			  
  const rightBig = l==2?'50':'0';
  const heightBig = l<=3?'100':'50';
  const topBig = l==3?'-50':'0';
  const skewMain = l<=2?0:-(l-4)*90/l;
  // 循环计算给每个奖项添加style属性
  list.forEach((item, i) => {
    // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
    // const angle = -(i * average + half);
    // const bigAge = l > 2 ? i * 360 / l : '0';
    const angle = -(i * average);		
    const bigAge = (l > 2 ? i * 360 / l  : 0) - half;
    // 增加 style 这个是给每一个奖项增加的样式
    item.style = `-webkit-transform: rotate(${-angle}deg);
      transform: rotate(${-angle}deg);
      width:${100/l*2}%;  
      margin-left: -${100/l}%;
      font-size:${BIGSIZE-l}px;`;
    //这是给每一个转盘背景新增的样式
    item.style2 = `-webkit-transform: rotate(${bigAge}deg);
      transform: rotate(${bigAge}deg) skewY(${skewMain}deg);
      right:${rightBig*i}%;
      height:${heightBig}%;
      top:${topBig}%;
      width:${l==1?100:50}%;`;
    // 记录每个奖项的角度范围
    angleList.push(angle);         
  });
  return list;
};

//抽奖
const doSpin = () => {
  if (isRotating) {
    return false;
  }
  if (spinChance.value <= 0) {
    return false;
  }
  spinLuckySpin().then(res => {
    const rewardItem = res.data || {};
    spinReward.value = rewardItem;
    prizeList.value.some((item, index) => {
      if(item.id == rewardItem.id) {
        prizeIndex.value = index
        return true;
      }
    })
    rotating();
  })	
};

const doSpinTen = () => {
  if (isRotating) {
    return false;
  }
  if (spinChance.value < 10) {
    return false;
  }
  spinTenTimes().then(res => {
    const rewardItem = res.data || [];
    spinReward.value = rewardItem;
    prizeIndex.value = null;
    rotating();
  })
}
//转盘转动角度
const rotating = () => {
  isRotating = true;
  const config = {
    duration: 5000, 
    circle: 8,
    mode: "ease-in-out"
  }
  // 计算角度      初始角度 + 多旋转的圈数 * 360 + 奖项的角度
  const angle = rotateAngle + config.circle * CIRCLE_ANGLE + angleList[prizeIndex.value || 0] - (rotateAngle % CIRCLE_ANGLE);
  rotateAngle = angle;
  rollStyle.value = `transform: rotate(${rotateAngle}deg); transition: transform 5000ms ease-in-out;`;
  playAudio('roll');
  // 旋转结束后，允许再次触发
  setTimeout(() => {
    isRotating = false;
    showReward.value = true;
    fetchLuckySpin();
  }, config.duration + 500);
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_RoateText = _resolveComponent("RoateText")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false,
      onClickOverlay: _cache[4] || (_cache[4] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_image, {
            class: "lucky-spin-title",
            src: require('@/assets/img/lucky-spin/lucky-spin.png')
          }, null, 8, ["src"]),
          _withDirectives(_createVNode(_component_van_icon, {
            class: "close-icon",
            name: "close",
            onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
          }, null, 512), [
            [_directive_audio, void 0, "close"]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('label.ultimate').toUpperCase()), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_image, {
                class: "currency-icon",
                src: require('@/assets/img/lucky-spin/currency.png')
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$filter.outputAmount(spinJackpot.value || 0, 0)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('luckySpin.chanceWin').toUpperCase()), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "lucky-wheel-bg-main",
              style: _normalizeStyle(rollStyle.value)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prizeList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`lucky-wheel-sector sector-${index}`),
                  style: _normalizeStyle(item.style2)
                }, null, 6))
              }), 256))
            ], 4),
            _createElementVNode("div", {
              class: "prize-list",
              style: _normalizeStyle(rollStyle.value)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prizeList.value, (prize, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: prize.id,
                  class: _normalizeClass(`prize-item item-${index}`),
                  style: _normalizeStyle(prize.style)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prize.name.split(' '), (item, nameIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "prize-name",
                      key: nameIndex
                    }, [
                      _createVNode(_component_RoateText, {
                        text: item,
                        fontSize: "12px",
                        radius: "120px"
                      }, null, 8, ["text"])
                    ]))
                  }), 128)),
                  (prize.cash && prize.award != 'ultimate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_RoateText, {
                          text: `P${_ctx.$filter.outputAmount(prize.cash)}`,
                          fontSize: "11px",
                          radius: "240px"
                        }, null, 8, ["text"])
                      ]))
                    : _createCommentVNode("", true)
                ], 6))
              }), 128))
            ], 4),
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              class: "wheel-pointer",
              src: _imports_0
            }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("img", {
              class: "wheel-center-img",
              src: _imports_1
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('luckySpin.remainSpin').toUpperCase()) + ":", 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(spinChance.value || 0), 1),
              _createVNode(_component_van_image, {
                class: "record-icon",
                src: require('@/assets/img/lucky-spin/record-btn.png'),
                onClick: _cache[1] || (_cache[1] = $event => (showRecord.value = true))
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_button, {
                class: "spin-btn",
                disabled: spinChance.value <= 0,
                onClick: doSpin
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.spin').toUpperCase()) + " X1", 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_van_button, {
                class: "spin-btn highlight",
                disabled: spinChance.value < 10,
                onClick: doSpinTen
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.spin').toUpperCase()) + " X10", 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(SpinLog, { logList: logList.value }, null, 8, ["logList"]),
              _createVNode(_component_van_image, {
                class: "go-icon",
                src: require('@/assets/img/lucky-spin/link.png'),
                onClick: _cache[2] || (_cache[2] = $event => (showWinnerRecord.value = true))
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode(GameBetTask),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "rule-btn flex justify-center",
            onClick: _cache[3] || (_cache[3] = $event => (showRule.value = true))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('luckySpin.howToPlay').toUpperCase()) + "?", 1)
          ])), [
            [_directive_audio]
          ])
        ])
      ]),
      _: 1
    }),
    (showReward.value)
      ? (_openBlock(), _createBlock(Reward, {
          key: 0,
          rewardItem: spinReward.value,
          prizeIndex: prizeIndex.value,
          onOnClose: _cache[5] || (_cache[5] = $event => (showReward.value = false)),
          onOnSpin: doSpin
        }, null, 8, ["rewardItem", "prizeIndex"]))
      : _createCommentVNode("", true),
    (showRecord.value)
      ? (_openBlock(), _createBlock(Record, {
          key: 1,
          onOnClose: _cache[6] || (_cache[6] = $event => (showRecord.value = false))
        }))
      : _createCommentVNode("", true),
    (showWinnerRecord.value)
      ? (_openBlock(), _createBlock(WinnerRecord, {
          key: 2,
          onOnClose: _cache[7] || (_cache[7] = $event => (showWinnerRecord.value = false))
        }))
      : _createCommentVNode("", true),
    (showRule.value)
      ? (_openBlock(), _createBlock(Rule, {
          key: 3,
          onOnClose: _cache[8] || (_cache[8] = $event => (showRule.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}